// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B3maG","colMin":"styles_colMin__2vjrl"};